import { createSlice } from "@reduxjs/toolkit";

const inquiry = createSlice({
  name: "inquiries",
  initialState: {
    data: [],
  },
  reducers: {
    getInquiries(state, action) {
      state.data = action.payload;
      state.loading = false;
    },
  },
});

export const { getInquiries } = inquiry.actions;
export default inquiry.reducer;
